import axiosInstance from "components/utils/axiosInstance";
import qs from "qs";
const API_BASE_URL = process.env.REACT_APP_TRADEPLUS_URL;

export const addOrder = async (data) => {
  const idempotencyKey = crypto.randomUUID(); // unique per attempt

  const response = await axiosInstance.post(
    `${API_BASE_URL}/Orders/SaveOrder`,
    data,
    {
      headers: {
        "Idempotency-Key": idempotencyKey,
      },
    },
  );

  return response.data;
};

// For TMMs/TDRs – with campaignIds
export const getRecentOrders = async ({
  campaignIds,
  startDate,
  endDate,
  skip = 0,
  take = 100,
}) => {
  const params = {
    campaignIds,
    startDate,
    endDate,
    skip,
    take,
  };

  const response = await axiosInstance.get(
    `${API_BASE_URL}/Orders/recent-orders`,
    {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }), // ✅ Fix for arrays
    },
  );

  return response.data;
};
// For Admin – no campaign filter
// service
// export const getAdminRecentOrders = async ({
//   startDate,
//   endDate,
//   campaignIds = [],
//   skip = 0,
//   take = 40,
// }) => {
//   const params = {
//     startDate,
//     endDate,
//     skip,
//     take,
//     campaignIds,
//   };

//   const response = await axiosInstance.get(
//     `${API_BASE_URL}/Orders/admin/recent-orders`,
//     {
//       params,
//       paramsSerializer: (params) =>
//         qs.stringify(params, { arrayFormat: "repeat" }),
//       //ensures campaignIds=66&campaignIds=69
//     },
//   );

//   return response.data; // returns { totalOrders, completedOrders, orders }
// };

export const getAdminRecentOrders = async (filters) => {
  const { page, pageSize, ...rest } = filters;

  const params = {
    ...rest,
    // Calculate skip/take for the C# backend
    skip: (page - 1) * pageSize,
    take: pageSize,
  };

  const response = await axiosInstance.get(
    `${API_BASE_URL}/Orders/admin/recent-orders`,
    {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
    },
  );

  return response.data;
};

export const getUnassignedOrders = async ({
  agentCode,
  outletPhone,
  startedAtUtc,
  orderSource,
}) => {
  const params = {
    agentCode,
    outletPhone,
    startedAtUtc,
    orderSource,
  };

  const response = await axiosInstance.get(`/Orders/unassigned-orders`, {
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
  });

  return response.data;
};
export const getAgentManagerRecentOrders = async ({
  startDate,
  endDate,
  campaignIds = [],
  companyId = null,
  skip = 0,
  take = 30,
}) => {
  // Omit empty/null values so URL query string stays clean
  const params = {
    ...(startDate && { startDate }),
    ...(endDate && { endDate }),
    skip,
    take,
    ...(campaignIds?.length > 0 && { campaignIds }),
    ...(companyId && { companyId }),
  };

  const response = await axiosInstance.get(
    `${API_BASE_URL}/Orders/agentManager/recent-orders`,
    {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
    },
  );

  return response.data;
};
// Service to update order status
export const addOrderStatusHistory = async ({ orderId, orderStatusId }) => {
  const payload = { orderId, orderStatusId };

  const response = await axiosInstance.post(
    `${API_BASE_URL}/Orders/AddOrderStatusHistory`,
    payload,
  );

  return response.data;
};

export const getCampaignOrdersPaged = async ({
  campaignId,
  pageNumber = 1,
  pageSize = 20,
}) => {
  const { data } = await axiosInstance.get(
    `${API_BASE_URL}/Campaign/OrdersPaged`,
    {
      params: { campaignId, pageNumber, pageSize },
    },
  );
  return data;
};

export const getClientRecentOrders = async ({
  clientId,
  startDate,
  endDate,
  campaignIds = [],
  skip = 0,
  take = 100,
}) => {
  const params = {
    clientId,
    startDate,
    endDate,
    skip,
    take,
  };

  // Include campaignIds only if available
  if (campaignIds?.length) params.campaignIds = campaignIds;

  const response = await axiosInstance.get(
    `${API_BASE_URL}/Orders/client/recent-orders`,
    {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }),
    },
  );

  return response.data;
};

export const downloadOrders = async (params) => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/Orders/client/download-orders`,
    {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
    },
  );
  return response.data;
};

export const downloadOrdersForAgentManager = async (params) => {
  const response = await axiosInstance.get(
    `/Orders/agentManager/download-orders`,
    {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
    },
  );
  return response.data;
};

export const deleteOrder = async (orderId, campaignId, reason = "") => {
  const response = await axiosInstance.delete(
    `/orders/deleteOrder/${orderId}/${campaignId}`,
    {
      params: { reason },
    },
  );
  return response.data;
};

// Agent-specific services
export const fetchAgentOrders = async (params) => {
  const res = await axiosInstance.get("Orders/agent/orders", { params });
  return res.data;
};

export const fetchOrderSummary = async (params) => {
  const res = await axiosInstance.get("Orders/agent/ordersummary", { params });
  return res.data;
};

export const updateAgentOrderStatus = async ({ orderId, orderStatusId }) => {
  return axiosInstance.post(`/Orders/AddOrderStatusHistory`, {
    orderId,
    orderStatusId,
  });
};

export const editOrder = async (payload) => {
  const response = await axiosInstance.post("/Orders/EditOrder", payload);
  return response.data;
};

export const fetchOrderEditLogs = async ({
  pageNumber = 1,
  pageSize = 10,
  orderId = null,
}) => {
  const params = { pageNumber, pageSize };
  if (orderId) params.orderId = orderId;
  const response = await axiosInstance.get("/Orders/edit-logs", { params });
  return response.data;
};

export const bulkMarkJunkSale = async (payload) => {
  const response = await axiosInstance.post("/Orders/bulk-junk-sale", payload);
  return response.data;
};
